// extracted by mini-css-extract-plugin
export default {"btn":"Button4_btn__8TrT-"};